import React from "react";
import { Backdrop, CircularProgress, Snackbar, Alert } from "@mui/material";
// import { useTranslation } from "react-i18next";

interface SubmitFeedbackProps {
  loading: boolean;
  error?: string;
  success?: string;
  onCloseError: () => void;
  onCloseSuccess: () => void;
}

const SubmitFeedback: React.FC<SubmitFeedbackProps> = ({
  loading,
  error,
  success,
  onCloseError,
  onCloseSuccess,
}) => {
  // const { t } = useTranslation();

  return (
    <>
      <Backdrop
        open={loading}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <CircularProgress color="primary" />
      </Backdrop>

      <Snackbar
        open={!!error}
        autoHideDuration={6000}
        onClose={onCloseError}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity="error" onClose={onCloseError}>
          {error}
        </Alert>
      </Snackbar>

      <Snackbar
        open={!!success}
        autoHideDuration={3000}
        onClose={onCloseSuccess}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity="success" onClose={onCloseSuccess}>
          {success}
        </Alert>
      </Snackbar>
    </>
  );
};

export default SubmitFeedback;
